import { useRef, type ReactNode } from "react";
import { FirebaseLoginView, type FirebaseSignInProvider } from "@firecms/firebase";
import type { FirebaseApp } from "firebase/app";
import type { FirebaseAuthController } from "@firecms/firebase";
import { AdminBootSplash } from "./AdminBootSplash";
import logoUrl from "../assets/logo.svg";

type AuthBootGateProps = {
  authLoading: boolean;
  canAccessMainView: boolean;
  authController: FirebaseAuthController;
  firebaseApp: FirebaseApp;
  signInOptions: FirebaseSignInProvider[];
  notAllowedError?: string;
  /** FireCMS initial loading (App only). */
  loading?: boolean;
  /** Waiting for auth extras (manager) after auth resolved. */
  pendingExtras?: boolean;
  children: ReactNode;
};

export function AuthBootGate({
  authLoading,
  canAccessMainView,
  authController,
  firebaseApp,
  signInOptions,
  notAllowedError,
  loading = false,
  pendingExtras = false,
  children,
}: AuthBootGateProps) {
  const hasLoadedOnce = useRef(false);

  if (!loading && !authLoading && !pendingExtras) {
    hasLoadedOnce.current = true;
  }

  if (authLoading || pendingExtras || (loading && !hasLoadedOnce.current)) {
    return <AdminBootSplash />;
  }

  if (!canAccessMainView) {
    return (
      <FirebaseLoginView
        authController={authController}
        firebaseApp={firebaseApp}
        signInOptions={signInOptions}
        logo={logoUrl}
        notAllowedError={notAllowedError}
        disableSignupScreen={true}
      />
    );
  }

  return <>{children}</>;
}
